import { render, staticRenderFns } from "./RolePopup.vue?vue&type=template&id=7b87923e&scoped=true&"
import script from "./RolePopup.vue?vue&type=script&lang=js&"
export * from "./RolePopup.vue?vue&type=script&lang=js&"
import style0 from "./RolePopup.vue?vue&type=style&index=0&id=7b87923e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b87923e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/otavio.cardoso.neto/Workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b87923e')) {
      api.createRecord('7b87923e', component.options)
    } else {
      api.reload('7b87923e', component.options)
    }
    module.hot.accept("./RolePopup.vue?vue&type=template&id=7b87923e&scoped=true&", function () {
      api.rerender('7b87923e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/roles/RolePopup.vue"
export default component.exports